import { render } from "./IconSansLactose.vue?vue&type=template&id=34bf7bb2"
import script from "./IconSansLactose.vue?vue&type=script&lang=js"
export * from "./IconSansLactose.vue?vue&type=script&lang=js"

import exportComponent from "D:\\perso\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__